import React from "react";
import PropTypes from "prop-types";
import { TextButton } from "components/core/Button";

export const AdditionalNamesV2 = ({ handleAddName, children }) => (
	<div className="additional-names">
		<div className="additional-name-input-groups">{children}</div>
		<TextButton
			color="blue"
			flush
			fullWidth={false}
			onClick={handleAddName}
			className="add-name-button"
		>
			<span>+</span> Add another name to this reservation
		</TextButton>
	</div>
);

AdditionalNamesV2.propTypes = {
	children: PropTypes.node.isRequired,
	handleAddName: PropTypes.func.isRequired
};
